import { FETCH_FACETS } from 'app/actions/types';

const initialState = {
  events: [],
  specificpeople: [],
  locations: [],
};

// eslint-disable-next-line complexity
export default (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_FACETS: {
      return action.facets;
    }
    default:
      return state;
  }
};
